/* eslint-disable max-len */
import { Action, createReducer, on } from '@ngrx/store';
import { ProductResponseData, ComponentData, HardwareData, ProductData } from 'src/app/model/api/data-rest';
import * as SoftwareUpdatesActions from './software-updates.actions';

export interface State {
	loadingProducts: boolean;
	productsResponseData: ProductResponseData;
	product?: ProductData;
	loadingProduct: boolean;
	hardwareByProductId: Record<number, HardwareData[]>;
	loadingHardwareByProductId: Record<number, boolean>;
	componentsByHardwareId: Record<number, ComponentData[]>;
	loadingComponentsByHardwareId: Record<number, boolean>;
	uploadingReleaseArtifactById: Record<number, boolean>;
	errorMessage?: string;
}

export const initialState: State = {
	loadingProducts: false,
	productsResponseData: undefined,
	product: undefined,
	loadingProduct: false,
	hardwareByProductId: {},
	loadingHardwareByProductId: {},
	componentsByHardwareId: {},
	loadingComponentsByHardwareId: {},
	uploadingReleaseArtifactById: {},
	errorMessage: undefined,
}

const softwareUpdatesReducer = createReducer(
	initialState,

	// --- Product ---
	on(SoftwareUpdatesActions.getProducts, (state) => ({ ...state, loadingProducts: true })),
	on(SoftwareUpdatesActions.getProductsSuccess, (state, payload) => ({ ...state, loadingProducts: false, productsResponseData: payload.productsResponseData })),
	on(SoftwareUpdatesActions.getProductsFailed, (state, payload) => ({ ...state, loadingProducts: false, errorMessage: payload.errorMessage })),

	on(SoftwareUpdatesActions.getProduct, (state) => ({ ...state, loadingProduct: true })),
	on(SoftwareUpdatesActions.getProductSuccess, (state, payload) => ({ ...state, loadingProduct: false, product: payload.product })),
	on(SoftwareUpdatesActions.getProductFailed, (state, payload) => ({ ...state, loadingProduct: false, errorMessage: payload.errorMessage })),

	// --- Hardware (mappa per prodotto) ---
	on(SoftwareUpdatesActions.getHardwareList, (state, payload) => ({
		...state,
		loadingHardwareByProductId: { ...state.loadingHardwareByProductId, [payload.productId]: true },
	})),
	on(SoftwareUpdatesActions.getHardwareListSuccess, (state, payload) => ({
		...state,
		hardwareByProductId: { ...state.hardwareByProductId, [payload.productId]: payload.hardware },
		loadingHardwareByProductId: { ...state.loadingHardwareByProductId, [payload.productId]: false },
	})),
	on(SoftwareUpdatesActions.getHardwareListFailed, (state, payload) => ({
		...state,
		loadingHardwareByProductId: { ...state.loadingHardwareByProductId, [payload.productId]: false },
		errorMessage: payload.errorMessage,
	})),

	// --- Component (mappa per hardware) ---
	on(SoftwareUpdatesActions.getComponents, (state, payload) => ({
		...state,
		loadingComponentsByHardwareId: { ...state.loadingComponentsByHardwareId, [payload.hardwareId]: true },
	})),
	on(SoftwareUpdatesActions.getComponentsSuccess, (state, payload) => ({
		...state,
		componentsByHardwareId: { ...state.componentsByHardwareId, [payload.hardwareId]: payload.components },
		loadingComponentsByHardwareId: { ...state.loadingComponentsByHardwareId, [payload.hardwareId]: false },
	})),
	on(SoftwareUpdatesActions.getComponentsFailed, (state, payload) => ({
		...state,
		loadingComponentsByHardwareId: { ...state.loadingComponentsByHardwareId, [payload.hardwareId]: false },
		errorMessage: payload.errorMessage,
	})),

	// --- Release artifact ---
	on(SoftwareUpdatesActions.uploadReleaseArtifact, (state, payload) => ({
		...state,
		uploadingReleaseArtifactById: { ...state.uploadingReleaseArtifactById, [payload.softwareReleaseId]: true },
	})),
	on(SoftwareUpdatesActions.uploadReleaseArtifactSuccess, (state, payload) => ({
		...state,
		uploadingReleaseArtifactById: { ...state.uploadingReleaseArtifactById, [payload.softwareReleaseId]: false },
	})),
	on(SoftwareUpdatesActions.uploadReleaseArtifactFailed, (state, payload) => ({
		...state,
		uploadingReleaseArtifactById: { ...state.uploadingReleaseArtifactById, [payload.softwareReleaseId]: false },
		errorMessage: payload.errorMessage,
	})),
);

export const reducer = (state: State | undefined, action: Action): State => softwareUpdatesReducer(state, action);
